// ABOUTME: Hook to load and update the singleton app_settings row.
// ABOUTME: Exposes feature flags (registration, courses, practice, daily challenge, speaking, chapter view).
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface AppSettings {
  registration_enabled: boolean;
  courses_enabled: boolean;
  telegram_bot_username: string;
  telegram_enabled: boolean;
  telegram_group_id: number | null;
  speaking_dialogues_enabled: boolean;
  speaking_pictures_enabled: boolean;
  speaking_topics_enabled: boolean;
  practice_enabled: boolean;
  daily_challenge_enabled: boolean;
  subscriptions_enabled: boolean;
  apple_auth_enabled: boolean;
  chapter_view_default: string;
  chapter_view_switch_visible: boolean;
  global_css: string;
}

const DEFAULT_SETTINGS: AppSettings = {
  registration_enabled: true,
  courses_enabled: true,
  telegram_bot_username: 'new_mnemozilla_921_bot',
  telegram_enabled: true,
  telegram_group_id: null,
  speaking_dialogues_enabled: false,
  speaking_pictures_enabled: false,
  speaking_topics_enabled: false,
  practice_enabled: true,
  daily_challenge_enabled: true,
  subscriptions_enabled: true,
  apple_auth_enabled: false,
  chapter_view_default: 'all',
  chapter_view_switch_visible: true,
  global_css: '',
};

export const useAppSettings = () => {
  const [settings, setSettings] = useState<AppSettings>(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const { data } = await supabase
      .from('app_settings' as any)
      .select('registration_enabled, courses_enabled, telegram_bot_username, telegram_enabled, telegram_group_id, speaking_dialogues_enabled, speaking_pictures_enabled, speaking_topics_enabled, practice_enabled, daily_challenge_enabled, subscriptions_enabled, apple_auth_enabled, chapter_view_default, chapter_view_switch_visible, global_css')
      .eq('id', 1)
      .single();
    if (data) setSettings(data as unknown as AppSettings);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const update = async (patch: Partial<AppSettings>) => {
    const updated = { ...settings, ...patch };
    setSettings(updated);
    await supabase
      .from('app_settings' as any)
      .update({ ...patch, updated_at: new Date().toISOString() } as any)
      .eq('id', 1);
  };

  return { settings, loading, update, reload: load };
};
